import React, {useMemo} from "react";
import {CustomCounter} from "components/CustomCounter";
import {IconCheckpoint} from "components/icons";
export const MarkingIcons = ({organization, markings, addCounterClass}) => {
  const isMarking = !!organization?.markingIds?.length;
  const marking = useMemo(
    () => markings?.filter(({id}) => organization?.markingIds?.includes(id)),
    [markings, organization?.markingIds]
  );
  const markingTooltip = useMemo(() => {
    if (isMarking && marking.length > 2)
      return `${marking.map(({description}) => description).join(",\n")}`;
    return null;
  }, [isMarking, marking]);

  return (
    <React.Fragment>
      {isMarking &&
        marking
          .slice(0, 2)
          .map(({id, name}) => <IconCheckpoint key={id} name={name} addClass="ml-1" />)}
      {isMarking && marking.length > 2 && (
        <CustomCounter
          count={marking.length - 2}
          small
          tooltip={markingTooltip}
          addClass={addCounterClass}
        />
      )}
    </React.Fragment>
  );
};
